import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withKeys as _withKeys, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-703c583b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-container" }
const _hoisted_2 = { class: "settings-container" }
const _hoisted_3 = { class: "topBar" }
const _hoisted_4 = { class: "monogram" }
const _hoisted_5 = {
  key: 0,
  class: "messages"
}
const _hoisted_6 = { class: "loadingMessages" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading messages…", -1))
const _hoisted_8 = {
  key: 1,
  class: "messages"
}
const _hoisted_9 = { class: "loadingMessages" }
const _hoisted_10 = {
  key: 0,
  class: "info"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading more messages…", -1))
const _hoisted_12 = {
  key: 1,
  class: "info"
}
const _hoisted_13 = {
  key: 3,
  class: "characterCount"
}

import TheLoading from "@/components/TheLoading.vue";
import MainSidebar from "@/components/MainSidebar.vue";
import router from "@/router";
import store from "@/store";
import axios from "axios";
import { ComputedRef, computed, onBeforeUnmount, onMounted, onUpdated, ref } from "vue";

type Friendship = {
  friendship_id: string;
  user: User;
};
type User = {
  user_id: string;
  name: string;
  avatar?: string;
};

// Refs

export default /*#__PURE__*/_defineComponent({
  __name: 'MessagesView',
  setup(__props) {

function checkScrollHeight(event: Event) {
  const messagesContainer = event.target as HTMLDivElement;

  if (
    messagesContainer.scrollHeight + messagesContainer.scrollTop - 100 <=
      messagesContainer.offsetHeight &&
    next_cursor.value
  ) {
    getMoreMessages();
  }
}

async function getMoreMessages() {
  if (loading.value) return;
  loading.value = true;

  await sleep(500);

  try {
    const { data } = await axios.post("/messages/get", {
      friend_id: current_user.value?.user_id,
      group_chat: false,
      cursor: next_cursor.value,
    });

    store.state.current_messages = store.state.current_messages.concat(data.messages);
    next_cursor.value = data.next_cursor;

    loading.value = false;
  } catch (err) {
    console.log(err);
    loading.value = false;
  }
}

function handleInput() {
  const textarea = message_textarea.value as HTMLTextAreaElement;
  changeTextAreaHeight();
  characters.value = textarea.value.length;
}

function changeTextAreaHeight() {
  // Reset height of message input for new window size
  const textarea = message_textarea.value as HTMLTextAreaElement;

  textarea.style.height = "auto";
  textarea.style.height = textarea.scrollHeight + 2 + "px"; // +2 is for the top and botton border
}

async function sendMessageOrAddLineBreak(event: KeyboardEvent) {
  if (event.shiftKey) return;

  event.preventDefault();

  const textarea = message_textarea.value as HTMLTextAreaElement;
  const message_text = textarea.value.trim();

  // If empty, don't send request
  if (!message_text) return;

  if (message_text.length > 1000) {
    alert("The limit is 1000 characters per message.");
    return;
  }

  const { data } = await axios.post("/messages/create", {
    group_chat: false,
    friend_id: current_user.value?.user_id,
    message_text,
  });

  store.state.current_messages.unshift(data);
  textarea.value = "";
  characters.value = 0;
  changeTextAreaHeight();

  document.querySelector(".messages")?.children[0].scrollIntoView();
}

addEventListener("resize", changeTextAreaHeight);

onBeforeUnmount(() => {
  store.state.current_messages = [];
  removeEventListener("resize", changeTextAreaHeight);
});

onUpdated(() => {
  if (!current_user.value) {
    router.push("/overview");
  }
});

// Types
const message_textarea = ref<HTMLTextAreaElement | null>(null);
const next_cursor = ref<string | null>(null);
const loading = ref(true);
const characters = ref(0);

const current_user: ComputedRef<User | undefined> = computed(() => {
  const user_id = router.currentRoute.value.params?.user_id;
  let user;

  for (const i in store.state.friends.current) {
    const friend = store.state.friends.current[i] as Friendship;

    if (friend.user.user_id == user_id) {
      user = friend.user;
    }
  }

  return user;
});

// Lifecycle hook
onMounted(async () => {
  await sleep(500);

  try {
    const { data } = await axios.post("/messages/get", {
      friend_id: current_user.value?.user_id,
      group_chat: false,
    });

    store.state.current_messages = data.messages;
    next_cursor.value = data.next_cursor;

    loading.value = false;
  } catch (err) {
    console.log(err);
    loading.value = false;
  }
});

async function sleep(milliseconds: number) {
  await new Promise((resolve) => {
    setTimeout(() => {
      resolve("done");
    }, milliseconds);
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MainSidebar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(current_user.value?.name.slice(0, 1).toUpperCase()), 1),
        _createElementVNode("h1", null, _toDisplayString(current_user.value?.name), 1)
      ]),
      (loading.value && !_unref(store).state.current_messages.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(TheLoading, {
                background: "#fff",
                loader_main: "#afafaf",
                loader_secondary: "#e6e6e6"
              }),
              _hoisted_7
            ])
          ]))
        : (!loading.value && !_unref(store).state.current_messages.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", null, "No messages. Say “Hey!” to " + _toDisplayString(current_user.value?.name) + " 👋", 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "messages",
              onScroll: checkScrollHeight
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.current_messages, (message) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: message.message_id,
                  class: _normalizeClass([
            message.sent_by == current_user.value?.user_id ? 'received' : 'sent',
            'message',
          ])
                }, _toDisplayString(message.message), 3))
              }), 128)),
              (loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(TheLoading, {
                      background: "#fff",
                      loader_main: "#afafaf",
                      loader_secondary: "#e6e6e6"
                    }),
                    _hoisted_11
                  ]))
                : _createCommentVNode("", true),
              (!loading.value && !next_cursor.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("p", null, "You started a conversation with " + _toDisplayString(current_user.value?.name) + ".", 1)
                  ]))
                : _createCommentVNode("", true)
            ], 32)),
      _createElementVNode("textarea", {
        ref_key: "message_textarea",
        ref: message_textarea,
        placeholder: "Type message…",
        rows: "1",
        cols: "1",
        onKeydown: _withKeys(sendMessageOrAddLineBreak, ["enter"]),
        onInput: handleInput
      }, null, 544),
      (characters.value > 500)
        ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
            _createElementVNode("span", {
              style: _normalizeStyle(characters.value > 1000 ? 'color: red' : 'color: inherit')
            }, _toDisplayString(characters.value), 5),
            _createTextVNode("/1000 ")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})